var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#00a8a8",
    d: "M330.609,46.469V0H181.391v46.469h-80.75V512h113.125v-84h84.453v84h113.141V46.469H330.609z M172.578,373.875         h-33.359v-54.219h33.359V373.875z M172.578,264.375h-33.359v-54.219h33.359V264.375z M172.578,154.906h-33.359v-54.203h33.359         V154.906z M239.313,373.875h-33.359v-54.219h33.359V373.875z M239.313,264.375h-33.359v-54.219h33.359V264.375z M239.313,154.906         h-33.359v-54.203h33.359V154.906z M306.047,373.875h-33.359v-54.219h33.359V373.875z M306.047,264.375h-33.359v-54.219h33.359         V264.375z M306.047,154.906h-33.359v-54.203h33.359V154.906z M372.781,373.875h-33.375v-54.219h33.375V373.875z M372.781,264.375         h-33.375v-54.219h33.375V264.375z M372.781,154.906h-33.375v-54.203h33.375V154.906z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.6581106b19d44296730e475a938b02da.svg";
export { ForwardRef as ReactComponent };